import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "middle text-2xl" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "flex align-items-center justify-content-center p-2" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center p-2" }
const _hoisted_5 = { class: "flex align-items-center justify-content-center p-2" }
const _hoisted_6 = { class: "flex align-items-center justify-content-center p-2" }

import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import {useI18n} from "vue-i18n";
import {inject, ref} from "vue";
import type {AxiosStatic} from "axios";
import {useRoute} from "vue-router";
import Message from "primevue/message";

interface FormDataType {
  user_name: string,
  user_password: string,
}

interface LoginDataType {
  j_username: string,
  j_password: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const axios = inject<AxiosStatic>('axios')
const htmlForm = ref()

const t = useI18n()
const formData = ref<FormDataType>({
  user_name: '',
  user_password: '',
})

const loginData = ref<LoginDataType>({
  j_username: '',
  j_password: ''
})

const route = useRoute()
console.log('Route params', route.query)


function handleFormSubmit() {
  loginData.value.j_username = formData.value.user_name
  loginData.value.j_password = formData.value.user_password
  setTimeout(()=>{
    htmlForm.value.submit()
  },1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      ref_key: "htmlForm",
      ref: htmlForm,
      action: "/j_security_check",
      method: "post",
      style: {"visibility":"hidden"}
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "j_username",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.j_username) = $event))
      }, null, 512), [
        [_vModelText, loginData.value.j_username]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "j_password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.value.j_password) = $event))
      }, null, 512), [
        [_vModelText, loginData.value.j_password]
      ])
    ], 512),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(route).query.error!==undefined)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Neplatné přihlášení")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(InputText), {
              modelValue: formData.value.user_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.user_name) = $event)),
              placeholder: _unref(t).t('your_id'),
              autofocus: "",
              onKeyup: _withKeys(handleFormSubmit, ["enter"])
            }, null, 8, ["modelValue", "placeholder", "onKeyup"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(InputText), {
              modelValue: formData.value.user_password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.user_password) = $event)),
              type: "password",
              onKeyup: _withKeys(handleFormSubmit, ["enter"]),
              placeholder: _unref(t).t('your_password')
            }, null, 8, ["modelValue", "onKeyup", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              type: "button",
              label: _unref(t).t('login'),
              onClick: handleFormSubmit,
              onKeyup: _withKeys(handleFormSubmit, ["enter"])
            }, null, 8, ["label", "onKeyup"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})